<app-sortable-section-desktop-tablet
  [showTitle]="isInventoryLanding"
  [sectionTitle]="'i18n.inventory.recentInventories' | translate"
  [sectionHeaders]="sectionHeaders"
  [selectedHeader]="selectedHeader"
  [hasSectionData]="inventories?.length === 0 && !searchKey ? false : true"
  [noDataText]="'i18n.inventory.noInventoriesToShow' | translate"
  [tabletHeaderButtonText]="tabletHeaderButtonText"
  (updateSortEventEmitter)="updateInventoriesSort($event)"
  (headerButtonEventEmitter)="handleHeaderButtonEvent($event)"
>
  <ion-row
    *cdkVirtualFor="
      let inventory of inventories;
      let i = index;
      trackBy: trackItem
    "
    [attr.data-cy]="'inventory-data-row-' + i"
    class="sortable-section-data-row"
    (click)="
      openInventoryWorksheet(
        $event,
        'inventory/inventory-worksheet/' + inventory?.inventoryId
      )
    "
  >
    <!-- Inventory Name, Last Updated -->
    <ion-col
      [attr.data-cy]="'inventory-data-name-last-updated-column-' + i"
      class="inventory-data-name-last-updated-col"
      size="3.65"
      *ngIf="inventory.status !== InventoryStatus.COMPLETED"
      offset="0.35"
    >
      <div [attr.data-cy]="'inventory-data-name-last-updated-section-' + i">
        <!-- Inventory Name -->
        <p
          [attr.data-cy]="'inventory-data-name-text-' + i"
          class="inventory-name"
        >
          {{ inventory?.inventoryName }} -
          {{ inventory?.inventoryDate | date: 'M/d/yyyy' }}
        </p>
        <!-- Last Updated -->
        <p
          [attr.data-cy]="'inventory-data-last-updated-user-text-' + i"
          class="inventory-last-updated"
        >
          {{ 'i18n.common.lastUpdatedBy' | translate }}
          {{
            !(
              inventory?.updatedByUser?.firstName ||
              inventory?.updatedByUser?.lastName
            )
              ? ('i18n.common.system' | translate) + ', '
              : inventory?.updatedByUser?.firstName !==
                inventory?.updatedByUser?.lastName
              ? inventory?.updatedByUser?.firstName +
                ' ' +
                inventory?.updatedByUser?.lastName +
                ', '
              : inventory?.updatedByUser?.firstName + ', '
          }}
        </p>
        <p
          [attr.data-cy]="'inventory-data-last-updated-date-text-' + i"
          class="inventory-last-updated"
        >
          {{
            'i18n.inventory.lastUpdatedDateInfo'
              | translate
                : {
                    userId: inventory?.updatedByUser?.userName || 'NO DATA',
                    updateDate:
                      (inventory?.ecomUpdateDtm | date: 'M/d/yyyy') || 'NO DATA'
                  }
          }}
        </p>
      </div>
    </ion-col>

    <ion-col
      size="0.3"
      offset="0"
      class="inventory-data-completed-col"
      *ngIf="
        inventory.status === InventoryStatus.COMPLETED &&
        inventory.sourceSystem !== InventorySourceSystem.ECOMR2
      "
      data-cy="inventory-completed-tab"
    >
      <div class="completed-text">
        {{ 'i18n.inventory.complete' | translate }}
      </div>
    </ion-col>

    <ion-col
      size="0.3"
      offset="0"
      class="inventory-data-migrated-col"
      *ngIf="inventory.sourceSystem === InventorySourceSystem.ECOMR2"
      data-cy="inventory-migrated-tab"
    >
      <div class="migrated-text">
        {{ 'i18n.inventory.inventoryMigration.migrated' | translate }}
      </div>
    </ion-col>

    <!-- Inventory Name, Last Updated: Completed version -->
    <ion-col
      [attr.data-cy]="'inventory-data-name-last-updated-column-' + i"
      class="inventory-data-name-last-updated-col"
      *ngIf="inventory.status === InventoryStatus.COMPLETED"
      size="3.65"
      offset="0.05"
    >
      <div [attr.data-cy]="'inventory-data-name-last-updated-section-' + i">
        <!-- Inventory Name -->
        <p
          [attr.data-cy]="'inventory-data-name-text-' + i"
          class="inventory-name"
        >
          {{ inventory?.inventoryName }} -
          {{ inventory?.inventoryDate | date: 'M/d/yyyy' }}
        </p>
        <!-- Last Updated -->
        <p
          [attr.data-cy]="'inventory-data-last-updated-user-text-' + i"
          class="inventory-last-updated"
        >
          {{ 'i18n.common.lastUpdatedBy' | translate }}
          {{
            !(
              inventory?.updatedByUser?.firstName ||
              inventory?.updatedByUser?.lastName
            )
              ? ('i18n.common.system' | translate) + ', '
              : inventory?.updatedByUser?.firstName !==
                inventory?.updatedByUser?.lastName
              ? inventory?.updatedByUser?.firstName +
                ' ' +
                inventory?.updatedByUser?.lastName +
                ', '
              : inventory?.updatedByUser?.firstName + ', '
          }}
        </p>
        <p
          [attr.data-cy]="'inventory-data-last-updated-date-text-' + i"
          class="inventory-last-updated"
        >
          {{
            'i18n.inventory.lastUpdatedDateInfo'
              | translate
                : {
                    userId: inventory?.updatedByUser?.userName || 'NO DATA',
                    updateDate:
                      (inventory?.ecomUpdateDtm | date: 'M/d/yyyy') || 'NO DATA'
                  }
          }}
        </p>
      </div>
    </ion-col>

    <!-- Created -->
    <ion-col
      [attr.data-cy]="'inventory-data-created-column-' + i"
      class="inventory-data-created-col"
      size="1.8"
      offset="0.25"
    >
      <p [attr.data-cy]="'inventory-data-created-date-text-' + i">
        {{ (inventory?.ecomCreatedDtm | date: 'M/d/yyyy') || 'NO DATA' }}
      </p>
    </ion-col>
    <!-- Products -->
    <ion-col
      [attr.data-cy]="'inventory-data-products-column-' + i"
      size="1.35"
      offset="0.25"
      [ngClass]="
        inventory?.numProductsByQuantities > 999 || inventory?.numProducts > 999
          ? 'product-chip-big'
          : 'product-chip-small'
      "
    >
      <div [attr.data-cy]="'inventory-data-products-section-' + i">
        <ion-badge
          [attr.data-cy]="'inventory-data-products-icon-' + i"
          mode="ios"
        >
          {{ inventory?.numProductsByQuantities }} /
          {{ inventory?.numProducts }}
        </ion-badge>
      </div>
    </ion-col>
    <!-- Value -->
    <ion-col
      [attr.data-cy]="'inventory-data-value-column-' + i"
      class="inventory-data-value-col"
      size="1.35"
      offset="0.25"
    >
      <p [attr.data-cy]="'inventory-data-value-text-' + i">
        {{
          (inventory?.totalPrice ? inventory?.totalPrice : '0.00') | currency
        }}
      </p>
    </ion-col>
    <!-- Copy Button -->
    <ion-col
      [attr.data-cy]="'inventory-data-buttons-column-' + i"
      class="ion-align-self-center"
      size="1.75"
      offset="0.25"
    >
      <ion-button
        [attr.data-cy]="'inventory-data-copy-button-' + i"
        class="usf-outline-green-button"
        (click)="copyInventory($event, inventory.inventoryId)"
      >
        {{ 'i18n.common.copy' | translate }}
      </ion-button>
    </ion-col>
    <!-- Inventory Options -->
    <ion-col
      [attr.data-cy]="'inventory-data-ellipsis-column-' + i"
      size="0.6"
      offset="0.15"
    >
      <div [attr.data-cy]="'inventory-data-ellipsis-section-' + i">
        <ion-icon
          [attr.data-cy]="'inventory-data-ellipsis-icon-' + i"
          [hidden]="false"
          name="ellipsis-vertical"
          size="small"
          (click)="openInventoryOptions($event, inventory)"
        ></ion-icon>
      </div>
    </ion-col>
  </ion-row>

  <ion-row
    *ngIf="inventories?.length === 0 && !!searchKey"
    data-cy="inventory-worksheet-count-mode-row"
    class="sortable-section-data-row no-card"
  >
    <ion-col data-cy="inventory-worksheet-no-search-results-section" size="12">
      <ng-container [ngTemplateOutlet]="noSearchResults"></ng-container>
    </ion-col>
  </ion-row>
</app-sortable-section-desktop-tablet>

<ng-template #noSearchResults>
  <div
    data-cy="all-inventories-no-search-results-container"
    class="all-inventories-no-search-results"
  >
    <span data-cy="all-inventories-no-search-results-text">
      {{ 'i18n.search.noSearchResults.noResultFound' | translate }}
    </span>
    <span data-cy="all-inventories-no-search-results-subtext">
      {{ 'i18n.search.noSearchResults.pleaseTryAgain' | translate }}
    </span>
  </div>
</ng-template>
